import React from "react";
import dayjs from "dayjs";

const PaymentReceipt = React.forwardRef(({ receiptData }, ref) => {
  return (
    <div ref={ref} className="max-w-md mx-auto p-6 bg-white font-mono">
      <div className="text-center border-b pb-4 mb-4">
        <h2 className="text-xl font-bold">PAYMENT RECEIPT</h2>
        <p className="text-sm text-gray-600">Receipt #{receiptData.receipt_number}</p>
        <p className="text-sm text-gray-600">{dayjs(receiptData.date).format("DD/MM/YYYY HH:mm:ss")}</p>
      </div>

      <div className="mb-4">
        <p><strong>Transaction Type:</strong> {receiptData.document_type === "invoice" ? "Sales Invoice" : "Purchase Order"}</p>
        <p><strong>Document #:</strong> {receiptData.document_number}</p>
        <p><strong>{receiptData.document_type === "invoice" ? "Customer" : "Supplier"}:</strong> {receiptData.party_name}</p>
      </div>

      <div className="mb-4">
        <p><strong>Payment Method:</strong> {receiptData.payment_method}</p>
        {receiptData.reference && <p><strong>Reference:</strong> {receiptData.reference}</p>}
        <p><strong>Payment Date:</strong> {dayjs(receiptData.payment_date).format("DD/MM/YYYY")}</p>
      </div>

      <div className="border-t border-b py-3 my-3">
        <div className="flex justify-between">
          <span><strong>Amount Paid:</strong></span>
          <span className="text-lg font-bold">OMR {receiptData.amount?.toFixed(3)}</span>
        </div>
        <div className="flex justify-between mt-2">
          <span>Previous Balance:</span>
          <span>OMR {receiptData.previous_balance?.toFixed(3)}</span>
        </div>
        <div className="flex justify-between mt-2">
          <span>New Balance:</span>
          <span>OMR {receiptData.current_balance?.toFixed(3)}</span>
        </div>
      </div>

      <div className="text-center text-sm text-gray-500 mt-6">
        <p>Thank you for your business!</p>
        <p className="mt-2">This is a computer generated receipt.</p>
      </div>
    </div>
  );
});

export default PaymentReceipt;